var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"add-cate-modal",attrs:{"hide-footer":"","title":"Thêm mới danh mục"}},[_c('CategoryForm',{attrs:{"initial-data":_vm.formData,"list-cate":_vm.listCate},on:{"submit":_vm.handleSubmit,"cancel":_vm.hideModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }